import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'

import Galaktika_Button from '../../assets/img/Galaktika_Enter_The_Council.png'

export default function Popup({ children }) {
  const [isOpen, setIsOpen] = useState(false)

  function closeModal() {
    setIsOpen(false)
  }

  function openModal() {
    setIsOpen(true)
  }

  return (
    <>
      <div className="flex relative z-30 w-5/6 md:w-3/5 lg:w-2/5 2xl:w-1/3 2xl:max-w-[700px]">
        <button
          className="flex items-center justify-center py-1 px-3 transition w-full"
          onClick={openModal}
        >
          <img
            alt="Enter the Council"
            className="hover:scale-105 duration-300 ease-in-out transition-all w-full"
            src={Galaktika_Button}
          ></img>
        </button>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-30" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-30 "
              onClick={closeModal}
            />
          </Transition.Child>

          <div
            className="fixed inset-0 overflow-y-auto z-40"
            onClick={closeModal}
          >
            <div className="flex min-h-full items-center justify-center p-4 text-center overflow-hidden">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-200"
                enterFrom="translate-y-[200%] z-0 opacity-0 scale-95"
                enterTo=" translate-y-[127%] z-50 opacity-100 scale-100"
                leave="ease-in duration-300"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                {children}
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
